import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ListSubheader from '@material-ui/core/ListSubheader';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import SupervisedUserCircleIcon from '@material-ui/icons/SupervisedUserCircle';
import BorderColorIcon from '@material-ui/icons/BorderColor';
import VideoLibraryIcon from '@material-ui/icons/VideoLibrary';
import DeveloperBoardOutlinedIcon from '@material-ui/icons/DeveloperBoardOutlined';
import CodeIcon from '@material-ui/icons/Code';
import AccountBalanceOutlinedIcon from '@material-ui/icons/AccountBalanceOutlined';
import CreditCardOutlinedIcon from '@material-ui/icons/CreditCardOutlined';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
    },
    nested: {
        paddingLeft: theme.spacing(4),
    },
    text: {
        color: '#3F51B5'
    }
}));

export default function SkillLists() {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const [back, setBack] = React.useState(false);
    const [payment, setPayment] = React.useState(false);


    const handleClick = () => {
        setOpen(!open);
    };
    const handleOpen = () => {
        setBack(!back);
    };
    const handlePayment = () => {
        setPayment(!payment);
    };
    return (
        <List
            component="nav"
            aria-labelledby="nested-list-subheader"
            subheader={
                <ListSubheader component="div" id="nested-list-subheader">
                    My Skills
        </ListSubheader>
            }
            className={classes.root}
        >
            <ListItem button className={classes.text} onClick={handleClick}>
                <ListItemIcon>
                    <DeveloperBoardOutlinedIcon />
                </ListItemIcon>
                <ListItemText textColor="primary" primary="Front-end Development" />
                {open ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    <ListItem button className={classes.nested}>
                        <ListItemIcon>
                            <CodeIcon />
                        </ListItemIcon>
                        <ListItemText primary="Html" />
                    </ListItem>
                </List>
                <List component="div" disablePadding>
                    <ListItem button className={classes.nested}>
                        <ListItemIcon>
                            <CodeIcon />
                        </ListItemIcon>
                        <ListItemText primary="Css" />
                    </ListItem>
                </List>
                <List component="div" disablePadding>
                    <ListItem button className={classes.nested}>
                        <ListItemIcon>
                            <CodeIcon />
                        </ListItemIcon>
                        <ListItemText primary="Bootstrap" />
                    </ListItem>
                </List>
                <List component="div" disablePadding>
                    <ListItem button className={classes.nested}>
                        <ListItemIcon>
                            <CodeIcon />
                        </ListItemIcon>
                        <ListItemText primary="Material Ui" />
                    </ListItem>
                </List>
                <List component="div" disablePadding>
                    <ListItem button className={classes.nested}>
                        <ListItemIcon>
                            <CodeIcon />
                        </ListItemIcon>
                        <ListItemText primary="Tailwind CSS" />
                    </ListItem>
                </List>
            </Collapse>

            <ListItem button className={classes.text} onClick={handleOpen}>
                <ListItemIcon>
                    <InboxIcon />
                </ListItemIcon>
                <ListItemText primary="Backend Development" />
                {open ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={back} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    <ListItem button className={classes.nested}>
                        <ListItemIcon>
                            <CodeIcon />
                        </ListItemIcon>
                        <ListItemText primary="MongoDb" />
                    </ListItem>
                </List>
                <List component="div" disablePadding>
                    <ListItem button className={classes.nested}>
                        <ListItemIcon>
                            <CodeIcon />
                        </ListItemIcon>
                        <ListItemText primary="Express Js" />
                    </ListItem>
                </List>
                <List component="div" disablePadding>
                    <ListItem button className={classes.nested}>
                        <ListItemIcon>
                            <CodeIcon />
                        </ListItemIcon>
                        <ListItemText primary="Node Js" />
                    </ListItem>
                </List>
            </Collapse>


            <ListItem button className={classes.text} onClick={handlePayment}>
                <ListItemIcon>
                    <AccountBalanceOutlinedIcon />
                </ListItemIcon>
                <ListItemText primary="Payment Module Integration" />
                {open ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={payment} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    <ListItem button className={classes.nested}>
                        <ListItemIcon>
                            <CreditCardOutlinedIcon />
                        </ListItemIcon>
                        <ListItemText primary="SSLCOMMERZ" />
                    </ListItem>
                </List>
                <List component="div" disablePadding>
                    <ListItem button className={classes.nested}>
                        <ListItemIcon>
                            <CreditCardOutlinedIcon />
                        </ListItemIcon>
                        <ListItemText primary="PortWallet" />
                    </ListItem>
                </List>
            </Collapse>
            <ListItem button>
                <ListItemIcon>
                    <SupervisedUserCircleIcon />
                </ListItemIcon>
                <ListItemText primary="Communication Management" />
            </ListItem>
            <ListItem button>
                <ListItemIcon>
                    <BorderColorIcon />
                </ListItemIcon>
                <ListItemText primary="Technical Content Writer" />
            </ListItem>
            <ListItem button>
                <ListItemIcon>
                    <VideoLibraryIcon />
                </ListItemIcon>
                <ListItemText primary="Technical Video Maker" />
            </ListItem>
        </List>
    );
}
